
import React from 'react';
import AdServiceCards from './AdServiceCards';
import AdCTA from './AdCTA';

const AdServicesSection: React.FC = () => {
  return (
    <section className="py-20 px-6 md:px-10 bg-gray-50 dark:bg-gray-800">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Tools That Lighten Your Load and Grow Your Business
          </h2>
        </div>
        
        <AdServiceCards />
        
        {/* CTA Section */}
        <AdCTA />
      </div>
    </section>
  );
};

export default AdServicesSection;
